// supports amounts of 4, 5 or 6 digits with or without decimal
// 3000 -> 3 000 15200 -> 15 200 1350.5343 -> 1 350.5343
export const formatAmount = (amount) => {
  const divByDecimal = (`${amount}`).split('.');
  const decimalPart = divByDecimal[1];
  const nonDecimalPart = divByDecimal[0];

  const l = nonDecimalPart.length;
  if (l < 4) {
    return `${nonDecimalPart}.${decimalPart ? decimalPart : ''}${
      decimalPart && decimalPart.length === 1 ? '0' : ''
    }${!decimalPart || (decimalPart && decimalPart.length === 0) ? '00' : ''}`;
  } else {
    const padded = (`${nonDecimalPart}`)
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g)
      .map((x) => x
        .split('')
        .reverse()
        .join(''))
      .reverse()
      .join(' ');
    return `${padded}.${decimalPart ? decimalPart : ''}${
      decimalPart && decimalPart.length === 1 ? '0' : ''
    }${!decimalPart || (decimalPart && decimalPart.length === 0) ? '00' : ''}`;
  }
};
